import SettingsProfile from './SettingsProfile';

export default SettingsProfile;
